export default __webpack_public_path__ + "static/media/g.23ae4f74.svg";